import { render, staticRenderFns } from "./editVideos.vue?vue&type=template&id=ba7ec504&scoped=true&lang=pug"
import script from "./editVideos.vue?vue&type=script&lang=js"
export * from "./editVideos.vue?vue&type=script&lang=js"
import style0 from "./editVideos.vue?vue&type=style&index=0&id=ba7ec504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7ec504",
  null
  
)

export default component.exports